<div class="modal-header">
  @if (isNewUser) {
    <h4 class="modal-title h5" translate>New user</h4>
  }
  @if (!isNewUser) {
    <h4 class="modal-title h5" translate>Edit user</h4>
  }
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form [formGroup]="userForm">
  <div class="modal-body">
    <div class="form-row">
      <!-- EMAIL -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="username" translate>E-mail</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <input (blur)="onUsernameChanged()" [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
            class="form-control"
            formControlName="username" id="username"
            name="username" type="email">
            @if (f.username.errors) {
              <div class="invalid-feedback">
                @if (f.username.errors.pattern) {
                  <span translate>E-mail address invalid</span>
                }
                @if (f.username.errors.required) {
                  <span translate>E-mail address required</span>
                }
                @if (f.username.errors.used) {
                  <span translate>E-mail address already used!</span>
                }
              </div>
            }
          </div>
        </div>

        <!--ROLE-->
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label for="role" translate>Role</label>
            <scitis-required-field-indicator></scitis-required-field-indicator>
            <ng-select [items]="possibleRoles" [ngClass]="{ 'is-invalid': submitted && f.role.errors }"
              bindLabel="roleName"
              bindValue="roleName" formControlName="role"
              id="role">
            </ng-select>
            <input [hidden]="true" [ngClass]="{ 'is-invalid': submitted && f.role.errors }" class="form-control"
              id="roleName" name="roleName"
              type="text">

              @if (submitted && f.role.errors) {
                <div class="invalid-feedback">
                  @if (f.role.errors.required) {
                    <span translate>Role required</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <div class="form-row">
          <!-- DISPLAY NAME -->
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label for="displayName" translate>Display name</label>
              <scitis-required-field-indicator></scitis-required-field-indicator>
              <input [ngClass]="{ 'is-invalid': submitted && f.displayName.errors }" class="form-control"
                formControlName="displayName" id="displayName"
                name="displayName" type="email">

                @if (submitted && f.displayName.errors) {
                  <div class="invalid-feedback">
                    @if (f.displayName.errors.required) {
                      <span translate>Display name required</span>
                    }
                  </div>
                }
              </div>
            </div>

            <!--ORGANIZATION-->
            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label for="parentId" translate>Organization</label>
                <scitis-required-field-indicator></scitis-required-field-indicator>
                @if (isLoadingOrganizations) {
                  <span class="fa-solid fa-spinner fa-spin ml-2"></span>
                }
                <ng-select [items]="possibleOrganizations" [ngClass]="{ 'is-invalid': submitted && f.parentId.errors }"
                  bindLabel="name"
                  bindValue="id" formControlName="parentId"
                  id="parentId">
                </ng-select>
                <input [hidden]="true" [ngClass]="{ 'is-invalid': submitted && f.parentId.errors }" class="form-control"
                  id="selectedParentId"
                  name="selectedParentId" type="text">

                  @if (submitted && f.parentId.errors) {
                    <div class="invalid-feedback">
                      @if (f.parentId.errors.required || f.parentId.errors.min) {
                        <span translate>Organization required</span>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>

            <div class="form-row">
              <!-- LANGUAGE -->
              <div class="col-12 col-lg-6">
                <div class="form-group">
                  <label for="language" translate>Language</label>
                  <scitis-required-field-indicator></scitis-required-field-indicator>
                  <ng-select [items]="LANGUAGES" [ngClass]="{ 'is-invalid': submitted && f.language.errors }" bindLabel="name"
                    bindValue="key" formControlName="language"
                    id="language">
                  </ng-select>
                  <input [hidden]="true" [ngClass]="{ 'is-invalid': submitted && f.language.errors }" class="form-control"
                    id="languageName" name="languageName"
                    type="text">
                  </div>
                </div>

                <!--MACHINERY GROUP-->
                <div class="col-12 col-lg-6">
                  <div class="form-group">
                    <label for="machineGroup" translate>Machinery group</label>
                    <scitis-required-field-indicator></scitis-required-field-indicator>
                    @if (isLoadingMachineGroups) {
                      <span class="fa-solid fa-spinner fa-spin ml-2"></span>
                    }
                    <ng-select [items]="machineGroupsList" [ngClass]="{ 'is-invalid': submitted && f.machineGroup.errors }"
                      bindLabel="name"
                      bindValue="id"
                      formControlName="machineGroup"
                      id="machineGroup">
                    </ng-select>
                    <input [hidden]="true" [ngClass]="{ 'is-invalid': submitted && f.machineGroup.errors }" class="form-control"
                      id="machineGroupName"
                      name="machineGroupName" type="text">

                      @if (submitted && f.machineGroup.errors) {
                        <div class="invalid-feedback">
                          @if (f.machineGroup.errors.required || f.machineGroup.errors.min) {
                            <span
                            translate>Machinery group required</span>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>

                @if (!isNewUserSuperAdmin) {
                  <!-- VISIBILITY MACHINERY GROUPS -->
                  <div class="divider"></div>
                  @if (isDistributorOrHigher) {
                    <div class="form-group">
                      <span class="form-label mb-0" translate>
                        Visible machinery groups
                      </span>
                      @if (isLoadingSubMachineGroups) {
                        <span class="fa-solid fa-spinner fa-spin ml-2"></span>
                      }
                      @if (machineryGroupsTreeDataStructure && f.machineGroup.value) {
                        <div class="scrollarea tree-selection"
                          [style.max-height]="300">
                          <div class="container">
                            @if (machineryGroupsTreeDataStructure) {
                              <scitis-tree-list
                                [listOptions]="machineryGroupsTreeDataStructure"
                                [isRootAvailableToChange]="!isWhiteListedUser"
                                [whiteListedMachineryGroups]="loggedUser.getWhiteListedMachineryGroups(true)">
                              </scitis-tree-list>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <div class="alert alert-info mb-0">
                    <span translate>Hint: Removing access to groups is not revertible by the user. To revert it please contact your administrator.</span>
                  </div>
                }
              </div>


              <div class="modal-footer">
                <div class="modal-footer-inner">
                  <div class="row align-items-center flex-fill">
                    <div class="col">
                      <scitis-required-field-indicator-explanation></scitis-required-field-indicator-explanation>
                    </div>
                    <div class="col-auto">
                      <button (click)="onCancel()" class="btn btn-outline-primary mr-2" type="button">
                        <span translate>Cancel</span>
                      </button>
                      <button class="btn btn-primary" type="button" (click)="onSave()"
                        [disabled]="isDisabledSaveButton || submitted">
                        <span translate>Save</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
